import { AccountStatusLabel, IAccount } from 'models/account';

const initData: IAccount = {
  id: '',
  status: {
    label: AccountStatusLabel.NEW,
    updatedBy: '',
    updatedAt: '',
  },
  ownerUserId: '',
  organizationId: '',
  ownerUserEmail: '',
  name: '',
  csmInfo: {
    name: '',
    email: '',
    meetLink: '',
  },
  taxLiability: {
    estimatedTaxLiability: 0,
    ytdTotalPaid: 0,
    updatedAt: '',
  },
  lastSyncedOpenTodos: '',
  hubspotContactId: '',
};

export const useAccountDataForAdminPage = (
  accountData: IAccount | undefined,
): IAccount => {
  if (!accountData) {
    return initData;
  }
  return { ...initData, ...accountData };
};
